import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { DisplayPricingForm, DisplayPricingFormType } from './DisplayPricingForm'
import { getDisplayPricingById, updateDisplayPricing } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Display Pricings',
    path: '/system/display-pricings'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditDisplayPricing = () => {
  const { pricingId } = useParams()
  const { createToast } = useAppContext()
  const [option, setOption] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const row = await getDisplayPricingById(pricingId)
        setOption(row)
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateDisplayPricing(pricingId, {
        keyNo: form.keyNo,
        pitch: form.pitch,
        boardMatrix: form.boardMatrix,
        calculatedBoardMatrix: form.calculatedBoardMatrix,
        noOfLines: form.noOfLines,
        noOfCharacters: form.noOfCharacters,
        modsH: form.modsH,
        modsL: form.modsL,
        dimsH: form.dimsH,
        dimsW: form.dimsW,
        sfPrice: form.sfPrice,
        dfPrice: form.dfPrice,
        typicalAmps120: form.typicalAmps120,
        maxAmps120: form.maxAmps120,
        typicalAmps240: form.typicalAmps240,
        maxAmps240: form.maxAmps240
      })
      if (row) {
        setOption(row)
        createToast('success', 'Display pricing updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Display Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Option Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <DisplayPricingForm
              type={DisplayPricingFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={option}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
